// extracted by mini-css-extract-plugin
export default {"generalContainer":"styles_generalContainer__4-qLP"};